import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import * as fromGameHistory from '@fantaz/game-history/data-access';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TournamentsEffects } from './+state/tournaments/tournaments.effects';
import { TournamentsFacade } from './+state/tournaments/tournaments.facade';
import * as fromTournaments from './+state/tournaments/tournaments.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromTournaments.TOURNAMENTS_FEATURE_KEY,
      fromTournaments.tournamentsReducer,
    ),
    EffectsModule.forFeature([TournamentsEffects]),
    StoreModule.forFeature(
      fromGameHistory.GAME_HISTORY_FEATURE_KEY,
      fromGameHistory.gameHistoryReducer,
    ),
    EffectsModule.forFeature([fromGameHistory.GameHistoryEffects]),
  ],
  providers: [TournamentsFacade],
})
export class TournamentDataAccessV2Module {}
